// extracted by mini-css-extract-plugin
export default {"firebaseUi":"AuthPage_firebaseUi__Lvgvw"};